/* tslint:disable */
/* eslint-disable */
/**
 * ElisTech API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.0
 * Contact: info@ideatech.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiV1SurveyUuidWalkPost200Response } from '../models';
// @ts-ignore
import type { ApiV1WalkWalkIdGet200Response } from '../models';
// @ts-ignore
import type { ApiV1WalkWalkIdLocationPost200Response } from '../models';
// @ts-ignore
import type { ApiV1WalkWalkIdLocationPostRequest } from '../models';
// @ts-ignore
import type { ApiV1WalkWalkIdLocationsPost200Response } from '../models';
// @ts-ignore
import type { ApiV1WalkWalkIdLocationsPostRequest } from '../models';
// @ts-ignore
import type { EditWalkRequest } from '../models';
// @ts-ignore
import type { SaveMeasurementsRequest } from '../models';
// @ts-ignore
import type { SaveMeasurementsResponse } from '../models';
/**
 * WalkApi - axios parameter creator
 */
export const WalkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get walk details
         * @param {string} walkId Walk UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdGet: async (walkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'walkId' is not null or undefined
            assertParamExists('apiV1WalkWalkIdGet', 'walkId', walkId)
            const localVarPath = `/api/v1/walk/{walkId}`
                .replace('{walkId}', encodeURIComponent(String(walkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get walk details
         * @param {string} walkId Walk UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdGet_1: async (walkId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'walkId' is not null or undefined
            assertParamExists('apiV1WalkWalkIdGet_1', 'walkId', walkId)
            const localVarPath = `/api/v1/walk/{walkId}`
                .replace('{walkId}', encodeURIComponent(String(walkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save location to a walk
         * @param {string} walkId Walk UUID
         * @param {ApiV1WalkWalkIdLocationPostRequest} [apiV1WalkWalkIdLocationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdLocationPost: async (walkId: string, apiV1WalkWalkIdLocationPostRequest?: ApiV1WalkWalkIdLocationPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'walkId' is not null or undefined
            assertParamExists('apiV1WalkWalkIdLocationPost', 'walkId', walkId)
            const localVarPath = `/api/v1/walk/{walkId}/location`
                .replace('{walkId}', encodeURIComponent(String(walkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1WalkWalkIdLocationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save location to a walk
         * @param {string} walkId Walk UUID
         * @param {ApiV1WalkWalkIdLocationPostRequest} [apiV1WalkWalkIdLocationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdLocationPost_2: async (walkId: string, apiV1WalkWalkIdLocationPostRequest?: ApiV1WalkWalkIdLocationPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'walkId' is not null or undefined
            assertParamExists('apiV1WalkWalkIdLocationPost_2', 'walkId', walkId)
            const localVarPath = `/api/v1/walk/{walkId}/location`
                .replace('{walkId}', encodeURIComponent(String(walkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1WalkWalkIdLocationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save multiple locations to a walk
         * @param {string} walkId Walk UUID
         * @param {ApiV1WalkWalkIdLocationsPostRequest} [apiV1WalkWalkIdLocationsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdLocationsPost: async (walkId: string, apiV1WalkWalkIdLocationsPostRequest?: ApiV1WalkWalkIdLocationsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'walkId' is not null or undefined
            assertParamExists('apiV1WalkWalkIdLocationsPost', 'walkId', walkId)
            const localVarPath = `/api/v1/walk/{walkId}/locations`
                .replace('{walkId}', encodeURIComponent(String(walkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1WalkWalkIdLocationsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save multiple locations to a walk
         * @param {string} walkId Walk UUID
         * @param {ApiV1WalkWalkIdLocationsPostRequest} [apiV1WalkWalkIdLocationsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdLocationsPost_3: async (walkId: string, apiV1WalkWalkIdLocationsPostRequest?: ApiV1WalkWalkIdLocationsPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'walkId' is not null or undefined
            assertParamExists('apiV1WalkWalkIdLocationsPost_3', 'walkId', walkId)
            const localVarPath = `/api/v1/walk/{walkId}/locations`
                .replace('{walkId}', encodeURIComponent(String(walkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiV1WalkWalkIdLocationsPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save measurement samples to a walk
         * @param {string} walkId Walk UUID
         * @param {SaveMeasurementsRequest} saveMeasurementsRequest Each sample is a positional array with a fixed element order: [0] recordedAt (ISO-8601, millisecond precision, required, non-null), [1] latitude (float|null), [2] longitude (float|null), [3] actualVoltage (int|null), [4] actualCurrent (int|null), [5] setpointAlarm (int|null), [6] setpointVoltage (int|null), [7] selectedMode (string|null). Each array must have exactly 8 elements; any index except [0] may be null and is stored as SQL NULL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdMeasurementsPost: async (walkId: string, saveMeasurementsRequest: SaveMeasurementsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'walkId' is not null or undefined
            assertParamExists('apiV1WalkWalkIdMeasurementsPost', 'walkId', walkId)
            // verify required parameter 'saveMeasurementsRequest' is not null or undefined
            assertParamExists('apiV1WalkWalkIdMeasurementsPost', 'saveMeasurementsRequest', saveMeasurementsRequest)
            const localVarPath = `/api/v1/walk/{walkId}/measurements`
                .replace('{walkId}', encodeURIComponent(String(walkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveMeasurementsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save measurement samples to a walk
         * @param {string} walkId Walk UUID
         * @param {SaveMeasurementsRequest} saveMeasurementsRequest Each sample is a positional array with a fixed element order: [0] recordedAt (ISO-8601, millisecond precision, required, non-null), [1] latitude (float|null), [2] longitude (float|null), [3] actualVoltage (int|null), [4] actualCurrent (int|null), [5] setpointAlarm (int|null), [6] setpointVoltage (int|null), [7] selectedMode (string|null). Each array must have exactly 8 elements; any index except [0] may be null and is stored as SQL NULL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdMeasurementsPost_4: async (walkId: string, saveMeasurementsRequest: SaveMeasurementsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'walkId' is not null or undefined
            assertParamExists('apiV1WalkWalkIdMeasurementsPost_4', 'walkId', walkId)
            // verify required parameter 'saveMeasurementsRequest' is not null or undefined
            assertParamExists('apiV1WalkWalkIdMeasurementsPost_4', 'saveMeasurementsRequest', saveMeasurementsRequest)
            const localVarPath = `/api/v1/walk/{walkId}/measurements`
                .replace('{walkId}', encodeURIComponent(String(walkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveMeasurementsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a walk
         * @param {string} walkId Walk UUID
         * @param {EditWalkRequest} [editWalkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdPatch: async (walkId: string, editWalkRequest?: EditWalkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'walkId' is not null or undefined
            assertParamExists('apiV1WalkWalkIdPatch', 'walkId', walkId)
            const localVarPath = `/api/v1/walk/{walkId}`
                .replace('{walkId}', encodeURIComponent(String(walkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editWalkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a walk
         * @param {string} walkId Walk UUID
         * @param {EditWalkRequest} [editWalkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdPatch_5: async (walkId: string, editWalkRequest?: EditWalkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'walkId' is not null or undefined
            assertParamExists('apiV1WalkWalkIdPatch_5', 'walkId', walkId)
            const localVarPath = `/api/v1/walk/{walkId}`
                .replace('{walkId}', encodeURIComponent(String(walkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication secret-key required
            await setApiKeyToObject(localVarHeaderParameter, "secret-key", configuration)

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editWalkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WalkApi - functional programming interface
 */
export const WalkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WalkApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get walk details
         * @param {string} walkId Walk UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WalkWalkIdGet(walkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1WalkWalkIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WalkWalkIdGet(walkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalkApi.apiV1WalkWalkIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get walk details
         * @param {string} walkId Walk UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WalkWalkIdGet_1(walkId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1WalkWalkIdGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WalkWalkIdGet_1(walkId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalkApi.apiV1WalkWalkIdGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save location to a walk
         * @param {string} walkId Walk UUID
         * @param {ApiV1WalkWalkIdLocationPostRequest} [apiV1WalkWalkIdLocationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WalkWalkIdLocationPost(walkId: string, apiV1WalkWalkIdLocationPostRequest?: ApiV1WalkWalkIdLocationPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1WalkWalkIdLocationPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WalkWalkIdLocationPost(walkId, apiV1WalkWalkIdLocationPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalkApi.apiV1WalkWalkIdLocationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save location to a walk
         * @param {string} walkId Walk UUID
         * @param {ApiV1WalkWalkIdLocationPostRequest} [apiV1WalkWalkIdLocationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WalkWalkIdLocationPost_2(walkId: string, apiV1WalkWalkIdLocationPostRequest?: ApiV1WalkWalkIdLocationPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1WalkWalkIdLocationPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WalkWalkIdLocationPost_2(walkId, apiV1WalkWalkIdLocationPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalkApi.apiV1WalkWalkIdLocationPost_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save multiple locations to a walk
         * @param {string} walkId Walk UUID
         * @param {ApiV1WalkWalkIdLocationsPostRequest} [apiV1WalkWalkIdLocationsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WalkWalkIdLocationsPost(walkId: string, apiV1WalkWalkIdLocationsPostRequest?: ApiV1WalkWalkIdLocationsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1WalkWalkIdLocationsPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WalkWalkIdLocationsPost(walkId, apiV1WalkWalkIdLocationsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalkApi.apiV1WalkWalkIdLocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save multiple locations to a walk
         * @param {string} walkId Walk UUID
         * @param {ApiV1WalkWalkIdLocationsPostRequest} [apiV1WalkWalkIdLocationsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WalkWalkIdLocationsPost_3(walkId: string, apiV1WalkWalkIdLocationsPostRequest?: ApiV1WalkWalkIdLocationsPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1WalkWalkIdLocationsPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WalkWalkIdLocationsPost_3(walkId, apiV1WalkWalkIdLocationsPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalkApi.apiV1WalkWalkIdLocationsPost_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save measurement samples to a walk
         * @param {string} walkId Walk UUID
         * @param {SaveMeasurementsRequest} saveMeasurementsRequest Each sample is a positional array with a fixed element order: [0] recordedAt (ISO-8601, millisecond precision, required, non-null), [1] latitude (float|null), [2] longitude (float|null), [3] actualVoltage (int|null), [4] actualCurrent (int|null), [5] setpointAlarm (int|null), [6] setpointVoltage (int|null), [7] selectedMode (string|null). Each array must have exactly 8 elements; any index except [0] may be null and is stored as SQL NULL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WalkWalkIdMeasurementsPost(walkId: string, saveMeasurementsRequest: SaveMeasurementsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveMeasurementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WalkWalkIdMeasurementsPost(walkId, saveMeasurementsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalkApi.apiV1WalkWalkIdMeasurementsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save measurement samples to a walk
         * @param {string} walkId Walk UUID
         * @param {SaveMeasurementsRequest} saveMeasurementsRequest Each sample is a positional array with a fixed element order: [0] recordedAt (ISO-8601, millisecond precision, required, non-null), [1] latitude (float|null), [2] longitude (float|null), [3] actualVoltage (int|null), [4] actualCurrent (int|null), [5] setpointAlarm (int|null), [6] setpointVoltage (int|null), [7] selectedMode (string|null). Each array must have exactly 8 elements; any index except [0] may be null and is stored as SQL NULL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WalkWalkIdMeasurementsPost_4(walkId: string, saveMeasurementsRequest: SaveMeasurementsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveMeasurementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WalkWalkIdMeasurementsPost_4(walkId, saveMeasurementsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalkApi.apiV1WalkWalkIdMeasurementsPost_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a walk
         * @param {string} walkId Walk UUID
         * @param {EditWalkRequest} [editWalkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WalkWalkIdPatch(walkId: string, editWalkRequest?: EditWalkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidWalkPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WalkWalkIdPatch(walkId, editWalkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalkApi.apiV1WalkWalkIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a walk
         * @param {string} walkId Walk UUID
         * @param {EditWalkRequest} [editWalkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1WalkWalkIdPatch_5(walkId: string, editWalkRequest?: EditWalkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiV1SurveyUuidWalkPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1WalkWalkIdPatch_5(walkId, editWalkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalkApi.apiV1WalkWalkIdPatch_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WalkApi - factory interface
 */
export const WalkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WalkApiFp(configuration)
    return {
        /**
         * 
         * @summary Get walk details
         * @param {string} walkId Walk UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdGet(walkId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1WalkWalkIdGet200Response> {
            return localVarFp.apiV1WalkWalkIdGet(walkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get walk details
         * @param {string} walkId Walk UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdGet_1(walkId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1WalkWalkIdGet200Response> {
            return localVarFp.apiV1WalkWalkIdGet_1(walkId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save location to a walk
         * @param {string} walkId Walk UUID
         * @param {ApiV1WalkWalkIdLocationPostRequest} [apiV1WalkWalkIdLocationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdLocationPost(walkId: string, apiV1WalkWalkIdLocationPostRequest?: ApiV1WalkWalkIdLocationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1WalkWalkIdLocationPost200Response> {
            return localVarFp.apiV1WalkWalkIdLocationPost(walkId, apiV1WalkWalkIdLocationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save location to a walk
         * @param {string} walkId Walk UUID
         * @param {ApiV1WalkWalkIdLocationPostRequest} [apiV1WalkWalkIdLocationPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdLocationPost_2(walkId: string, apiV1WalkWalkIdLocationPostRequest?: ApiV1WalkWalkIdLocationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1WalkWalkIdLocationPost200Response> {
            return localVarFp.apiV1WalkWalkIdLocationPost_2(walkId, apiV1WalkWalkIdLocationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save multiple locations to a walk
         * @param {string} walkId Walk UUID
         * @param {ApiV1WalkWalkIdLocationsPostRequest} [apiV1WalkWalkIdLocationsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdLocationsPost(walkId: string, apiV1WalkWalkIdLocationsPostRequest?: ApiV1WalkWalkIdLocationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1WalkWalkIdLocationsPost200Response> {
            return localVarFp.apiV1WalkWalkIdLocationsPost(walkId, apiV1WalkWalkIdLocationsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save multiple locations to a walk
         * @param {string} walkId Walk UUID
         * @param {ApiV1WalkWalkIdLocationsPostRequest} [apiV1WalkWalkIdLocationsPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdLocationsPost_3(walkId: string, apiV1WalkWalkIdLocationsPostRequest?: ApiV1WalkWalkIdLocationsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1WalkWalkIdLocationsPost200Response> {
            return localVarFp.apiV1WalkWalkIdLocationsPost_3(walkId, apiV1WalkWalkIdLocationsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save measurement samples to a walk
         * @param {string} walkId Walk UUID
         * @param {SaveMeasurementsRequest} saveMeasurementsRequest Each sample is a positional array with a fixed element order: [0] recordedAt (ISO-8601, millisecond precision, required, non-null), [1] latitude (float|null), [2] longitude (float|null), [3] actualVoltage (int|null), [4] actualCurrent (int|null), [5] setpointAlarm (int|null), [6] setpointVoltage (int|null), [7] selectedMode (string|null). Each array must have exactly 8 elements; any index except [0] may be null and is stored as SQL NULL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdMeasurementsPost(walkId: string, saveMeasurementsRequest: SaveMeasurementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SaveMeasurementsResponse> {
            return localVarFp.apiV1WalkWalkIdMeasurementsPost(walkId, saveMeasurementsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save measurement samples to a walk
         * @param {string} walkId Walk UUID
         * @param {SaveMeasurementsRequest} saveMeasurementsRequest Each sample is a positional array with a fixed element order: [0] recordedAt (ISO-8601, millisecond precision, required, non-null), [1] latitude (float|null), [2] longitude (float|null), [3] actualVoltage (int|null), [4] actualCurrent (int|null), [5] setpointAlarm (int|null), [6] setpointVoltage (int|null), [7] selectedMode (string|null). Each array must have exactly 8 elements; any index except [0] may be null and is stored as SQL NULL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdMeasurementsPost_4(walkId: string, saveMeasurementsRequest: SaveMeasurementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SaveMeasurementsResponse> {
            return localVarFp.apiV1WalkWalkIdMeasurementsPost_4(walkId, saveMeasurementsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a walk
         * @param {string} walkId Walk UUID
         * @param {EditWalkRequest} [editWalkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdPatch(walkId: string, editWalkRequest?: EditWalkRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidWalkPost200Response> {
            return localVarFp.apiV1WalkWalkIdPatch(walkId, editWalkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a walk
         * @param {string} walkId Walk UUID
         * @param {EditWalkRequest} [editWalkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1WalkWalkIdPatch_5(walkId: string, editWalkRequest?: EditWalkRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiV1SurveyUuidWalkPost200Response> {
            return localVarFp.apiV1WalkWalkIdPatch_5(walkId, editWalkRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WalkApi - object-oriented interface
 */
export class WalkApi extends BaseAPI {
    /**
     * 
     * @summary Get walk details
     * @param {string} walkId Walk UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1WalkWalkIdGet(walkId: string, options?: RawAxiosRequestConfig) {
        return WalkApiFp(this.configuration).apiV1WalkWalkIdGet(walkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get walk details
     * @param {string} walkId Walk UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1WalkWalkIdGet_1(walkId: string, options?: RawAxiosRequestConfig) {
        return WalkApiFp(this.configuration).apiV1WalkWalkIdGet_1(walkId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save location to a walk
     * @param {string} walkId Walk UUID
     * @param {ApiV1WalkWalkIdLocationPostRequest} [apiV1WalkWalkIdLocationPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1WalkWalkIdLocationPost(walkId: string, apiV1WalkWalkIdLocationPostRequest?: ApiV1WalkWalkIdLocationPostRequest, options?: RawAxiosRequestConfig) {
        return WalkApiFp(this.configuration).apiV1WalkWalkIdLocationPost(walkId, apiV1WalkWalkIdLocationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save location to a walk
     * @param {string} walkId Walk UUID
     * @param {ApiV1WalkWalkIdLocationPostRequest} [apiV1WalkWalkIdLocationPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1WalkWalkIdLocationPost_2(walkId: string, apiV1WalkWalkIdLocationPostRequest?: ApiV1WalkWalkIdLocationPostRequest, options?: RawAxiosRequestConfig) {
        return WalkApiFp(this.configuration).apiV1WalkWalkIdLocationPost_2(walkId, apiV1WalkWalkIdLocationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save multiple locations to a walk
     * @param {string} walkId Walk UUID
     * @param {ApiV1WalkWalkIdLocationsPostRequest} [apiV1WalkWalkIdLocationsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1WalkWalkIdLocationsPost(walkId: string, apiV1WalkWalkIdLocationsPostRequest?: ApiV1WalkWalkIdLocationsPostRequest, options?: RawAxiosRequestConfig) {
        return WalkApiFp(this.configuration).apiV1WalkWalkIdLocationsPost(walkId, apiV1WalkWalkIdLocationsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save multiple locations to a walk
     * @param {string} walkId Walk UUID
     * @param {ApiV1WalkWalkIdLocationsPostRequest} [apiV1WalkWalkIdLocationsPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1WalkWalkIdLocationsPost_3(walkId: string, apiV1WalkWalkIdLocationsPostRequest?: ApiV1WalkWalkIdLocationsPostRequest, options?: RawAxiosRequestConfig) {
        return WalkApiFp(this.configuration).apiV1WalkWalkIdLocationsPost_3(walkId, apiV1WalkWalkIdLocationsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save measurement samples to a walk
     * @param {string} walkId Walk UUID
     * @param {SaveMeasurementsRequest} saveMeasurementsRequest Each sample is a positional array with a fixed element order: [0] recordedAt (ISO-8601, millisecond precision, required, non-null), [1] latitude (float|null), [2] longitude (float|null), [3] actualVoltage (int|null), [4] actualCurrent (int|null), [5] setpointAlarm (int|null), [6] setpointVoltage (int|null), [7] selectedMode (string|null). Each array must have exactly 8 elements; any index except [0] may be null and is stored as SQL NULL.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1WalkWalkIdMeasurementsPost(walkId: string, saveMeasurementsRequest: SaveMeasurementsRequest, options?: RawAxiosRequestConfig) {
        return WalkApiFp(this.configuration).apiV1WalkWalkIdMeasurementsPost(walkId, saveMeasurementsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save measurement samples to a walk
     * @param {string} walkId Walk UUID
     * @param {SaveMeasurementsRequest} saveMeasurementsRequest Each sample is a positional array with a fixed element order: [0] recordedAt (ISO-8601, millisecond precision, required, non-null), [1] latitude (float|null), [2] longitude (float|null), [3] actualVoltage (int|null), [4] actualCurrent (int|null), [5] setpointAlarm (int|null), [6] setpointVoltage (int|null), [7] selectedMode (string|null). Each array must have exactly 8 elements; any index except [0] may be null and is stored as SQL NULL.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1WalkWalkIdMeasurementsPost_4(walkId: string, saveMeasurementsRequest: SaveMeasurementsRequest, options?: RawAxiosRequestConfig) {
        return WalkApiFp(this.configuration).apiV1WalkWalkIdMeasurementsPost_4(walkId, saveMeasurementsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a walk
     * @param {string} walkId Walk UUID
     * @param {EditWalkRequest} [editWalkRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1WalkWalkIdPatch(walkId: string, editWalkRequest?: EditWalkRequest, options?: RawAxiosRequestConfig) {
        return WalkApiFp(this.configuration).apiV1WalkWalkIdPatch(walkId, editWalkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a walk
     * @param {string} walkId Walk UUID
     * @param {EditWalkRequest} [editWalkRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiV1WalkWalkIdPatch_5(walkId: string, editWalkRequest?: EditWalkRequest, options?: RawAxiosRequestConfig) {
        return WalkApiFp(this.configuration).apiV1WalkWalkIdPatch_5(walkId, editWalkRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

